
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 20,
  viewBox: "0 0 17 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.787 8.734 2.28.47A1.5 1.5 0 0 0 .205.987 1.487 1.487 0 0 0 0 1.738v16.525a1.494 1.494 0 0 0 1.5 1.487c.277 0 .548-.076.784-.22l13.504-8.263a1.481 1.481 0 0 0 0-2.531v-.002ZM1.5 18.244V1.75L14.984 10 1.5 18.245Z",
  fill: "#FF82A6"
})));

      const __svgRaw = "<svg width=\"17\" height=\"20\" viewBox=\"0 0 17 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M15.7875 8.7339L2.28 0.470781C2.05227 0.33133 1.79144 0.255201 1.52445 0.250257C1.25746 0.245313 0.993989 0.311732 0.76125 0.442655C0.530728 0.571545 0.338696 0.759511 0.204904 0.987222C0.0711107 1.21493 0.000385179 1.47417 0 1.73828V18.2627C0.00173697 18.6588 0.160719 19.0381 0.441997 19.3171C0.723276 19.5961 1.10383 19.752 1.5 19.7505C1.77652 19.7503 2.04767 19.6741 2.28375 19.5302L15.7875 11.267C16.0046 11.1347 16.184 10.9488 16.3084 10.7272C16.4329 10.5055 16.4983 10.2556 16.4983 10.0014C16.4983 9.7472 16.4329 9.49727 16.3084 9.27563C16.184 9.05398 16.0046 8.86808 15.7875 8.73578V8.7339ZM1.5 18.2448V1.75047L14.9841 10.0005L1.5 18.2448Z\" fill=\"#FF82A6\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/play.ab8469a5b0743719778d22c00d22442c.svg"),
        {
          React: SvgPlay,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      